interface FilterOption {
  label: string;
  value: string;
}

interface FilterPanelProps {
  genreOptions: string[];
  regionOptions: string[];
  yearOptions: string[];
  ratingOptions: FilterOption[];
  genre: string;
  region: string;
  year: string;
  rating: string;
  onGenre: (v: string) => void;
  onRegion: (v: string) => void;
  onYear: (v: string) => void;
  onRating: (v: string) => void;
  onReset: () => void;
}

function ChipGroup({
  title,
  icon,
  options,
  value,
  onChange,
}: {
  title: string;
  icon: string;
  options: string[];
  value: string;
  onChange: (v: string) => void;
}) {
  return (
    <div className="mb-6 last:mb-0">
      <h3 className="flex items-center gap-2 font-heading font-semibold text-sm text-foreground-900 mb-3">
        <i className={`${icon} text-primary-500 text-base`}></i>
        {title}
      </h3>
      <div className="flex flex-wrap gap-2">
        {options.map((opt) => (
          <button
            key={opt}
            type="button"
            onClick={() => onChange(opt)}
            className={`px-3 py-1.5 rounded-md text-xs cursor-pointer border transition-colors whitespace-nowrap ${
              value === opt
                ? "bg-primary-500 border-primary-500 text-background-50"
                : "bg-background-50 border-background-200 text-foreground-600 hover:border-primary-300 hover:text-primary-600"
            }`}
          >
            {opt}
          </button>
        ))}
      </div>
    </div>
  );
}

export default function FilterPanel({
  genreOptions,
  regionOptions,
  yearOptions,
  ratingOptions,
  genre,
  region,
  year,
  rating,
  onGenre,
  onRegion,
  onYear,
  onRating,
  onReset,
}: FilterPanelProps) {
  return (
    <div className="bg-background-50 border border-background-200 rounded-lg p-5">
      <div className="flex items-center justify-between mb-5">
        <h2 className="font-heading font-bold text-base text-foreground-950 flex items-center gap-2">
          <i className="ri-filter-3-line text-primary-500"></i>
          筛选条件
        </h2>
        <button
          type="button"
          onClick={onReset}
          className="text-xs text-foreground-500 hover:text-primary-600 cursor-pointer flex items-center gap-1"
        >
          <i className="ri-refresh-line"></i>
          重置
        </button>
      </div>

      <ChipGroup
        title="影片类型"
        icon="ri-price-tag-3-line"
        options={genreOptions}
        value={genre}
        onChange={onGenre}
      />
      <ChipGroup
        title="地区"
        icon="ri-earth-line"
        options={regionOptions}
        value={region}
        onChange={onRegion}
      />
      <ChipGroup
        title="上映年份"
        icon="ri-calendar-line"
        options={yearOptions}
        value={year}
        onChange={onYear}
      />

      <div>
        <h3 className="flex items-center gap-2 font-heading font-semibold text-sm text-foreground-900 mb-3">
          <i className="ri-star-line text-primary-500 text-base"></i>
          评分区间
        </h3>
        <div className="flex flex-wrap gap-2">
          {ratingOptions.map((opt) => (
            <button
              key={opt.value}
              type="button"
              onClick={() => onRating(opt.value)}
              className={`px-3 py-1.5 rounded-md text-xs cursor-pointer border transition-colors whitespace-nowrap ${
                rating === opt.value
                  ? "bg-primary-500 border-primary-500 text-background-50"
                  : "bg-background-50 border-background-200 text-foreground-600 hover:border-primary-300 hover:text-primary-600"
              }`}
            >
              {opt.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}